import React from 'react';

import { Switch } from '@chakra-ui/react';
import { useField } from 'formik';

import { FormikSwitchProps } from './FormikSwitch.props';

const FormikSwitchView = ({
  name,
  readOnly = false,
  ...props
}: FormikSwitchProps): JSX.Element => {
  const [{ value }, , field] = useField(name);

  //pass prop toggleSwitch as a prop if you want to toggle from the parent

  return (
    <Switch
      id={name}
      name={name}
      colorScheme="primary"
      isReadOnly={readOnly}
      {...props}
      isChecked={props.toggleSwitch ?? value}
      onChange={(event) => {
        const newValue = event.target.checked;
        props.onChange?.(newValue);
        field.setValue(newValue);
      }}
    />
  );
};

export default FormikSwitchView;
